
import { PropType } from "vue";
import { Vue, Options } from "vue-class-component";
import formatInputMoney from "@/app/infrastructures/misc/common-library/FormatInputMoney";
import formatPrice from "@/app/infrastructures/misc/common-library/v2/FormatPrice";
import { configPrice } from "@/app/infrastructures/misc/common-library/modules/Price";
import parseInputFloatToFloat from "@/app/infrastructures/misc/common-library/ParseInputFloatToFloat";
import { BalanceController } from "@/app/ui/controllers/BalanceController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BalanceLimitController } from "@/app/ui/controllers/BalanceLimitController";
import { BeneficiaryAccountController } from "@/app/ui/controllers/BeneficiaryAccountController";
import { AuthController } from "@/app/ui/controllers/AuthController";
import debounce from "lodash/debounce";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import { FlagsPermissionSaldo } from "@/feature-flags/flags-permission-saldo";
import { FlagsPermissionCodBalance } from "@/feature-flags/flags-permission-cod-balance";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { FlagsOtp } from "@/feature-flags/flags-otp";
import { recaptchaV3 } from "@/app/infrastructures/misc/common-library/RecaptchaV3";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { OtpRequest } from "@/data/payload/api/AuthRequest";
import { WithdrawBalanceRequest } from "@/data/payload/api/BalanceRequest";
import OtpDisclaimer from "@/app/ui/components/modal-otp/otp-disclaimer.vue";
import { formatInputByCountry, parseByCountry } from "@/app/infrastructures/misc/Utils";
@Options({
  components: {
    OtpDisclaimer
  },
  props: {
    onClose: {
      default: Function as PropType<() => void>,
      type: Function
    },
    balanceType: {
      default: "balance",
      type: String
    }
  },
  computed: {
    isVisibleRequest() {
      if (this.props.balanceType === "cod") {
        return FlagsPermissionCodBalance.permission_cod_balance_withdraw_request_detail.isEnabled();
      }
      return FlagsPermissionSaldo.permission_saldo_withdraw_request_detail.isEnabled();
    }
  }
})
export default class ModalWithdraw extends Vue {
  props: any = this.$props;
  created() {
    this.getBalanceList();
    this.getBeneficiaryAccount();
  }

  get countryCode() {
    const code = AccountController.accountData?.countryCode;
    return code?.toUpperCase() ?? "ID";
  }

  get currencyPrefix() {
    return this.countryCode === "MY" ? "RM" : "Rp";
  }

  get isLoadingData() {
    return this.loadingBeneficiary || this.loadingBalanceRules;
  }

  form = {
    accountNumber: "" as any
  };

  amountWithdrawal = "";
  passwordType = "password";
  iconType = "eye-slash";
  password = "";
  isModalOtp = false;
  tokenFromOTP = "";
  otp = "";
  emailUser = "";
  phoneUser = "";
  errorMessageOtp = "";

  get isDisabled() {
    return (
      this.amountWithdrawal === "" ||
      !this.isPasswordValidate ||
      this.errorAmountWithdrawal ||
      this.beneficiaryModelValue === "-"
    );
  }

  get errorAmountWithdrawal() {
    return this.errorMinWithdraw || this.errorMinBalance;
  }
  get errorMinWithdraw() {
    const minWithdrawal = Number(this.balanceRules[0]?.minWithdraw);
    const amountToWithdraw = parseByCountry(this.amountWithdrawal, { country: this.countryCode });
    return amountToWithdraw < minWithdrawal;
  }
  get errorMinBalance() {
    const minBalance = Number(this.balanceRules[0]?.minBalance);
    const amountToWithdraw = parseByCountry(this.amountWithdrawal, { country: this.countryCode });
    const balanceAvailable = this.balance;
    if (this.props.balanceType === "balance") {
      return balanceAvailable - amountToWithdraw < minBalance;
    }
    return amountToWithdraw > balanceAvailable;
  }

  showPassword() {
    if (this.passwordType === "password" && this.iconType === "eye-slash") {
      this.passwordType = "text";
      this.iconType = "eye";
    } else {
      this.passwordType = "password";
      this.iconType = "eye-slash";
    }
  }

  // Only number
  formatted() {
    if (/^0/.test(this.amountWithdrawal)) {
      this.amountWithdrawal = this.amountWithdrawal.replace(/^0/, "");
    } else {
      this.amountWithdrawal = formatInputByCountry(this.amountWithdrawal, { type: "money", country: this.countryCode });
    }
  }
  formatPrice(val: any) {
    const currency = this.countryCode === "MY" ? "MYR" : "IDR";
    return formatPrice(val, "", currency);
  }

  // balance
  get balance() {
    return this.props.balanceType === "balance"
      ? BalanceController.balanceData.walletBalance
      : BalanceController.balanceData.walletBalanceCod;
  }
  get balanceTitle() {
    return this.props.balanceType === "balance"
      ? this.$t("balance.withdraw.balanceAvailable")
      : this.$t("balance.withdraw.codIncomeTitle");
  }

  get accountCurrency(): "IDR" | "MYR" {
    return this.dataProfile.accountCurrency === "MYR" ? "MYR" : "IDR";
  }

  get withdrawCurrencyPrefix() {
    return configPrice[this.accountCurrency]?.prefix ?? "Rp";
  }

  get accountType() {
    if (AccountController.accountData.account_type === "partner") {
      return AccountController.accountData.account_type_detail.type;
    }
    return AccountController.accountData.account_type;
  }

  // get limit rules
  async getBalanceList() {
    BalanceLimitController.getBalanceList({
      page: 1,
      limit: 10
    });
  }
  get loadingBalanceRules() {
    return BalanceLimitController.isLoading;
  }
  get balanceData() {
    return BalanceLimitController.balanceData.data;
  }
  get balanceRules() {
    if (this.accountType === "pos") {
      return this.balanceData.filter((item: any) => {
        return (
          item.appliedTo.toLowerCase() === this.accountType &&
          item.metaCodDelivery ===
            this.dataProfile.account_type_detail.isCodDelivery
        );
      });
    }
    return this.balanceData.filter((item: any) => {
      return item.appliedTo.toLowerCase() === this.accountType;
    });
  }

  // get beneficiary account
  async getBeneficiaryAccount() {
    BeneficiaryAccountController.getBeneficiaryAccList({
      page: 1,
      limit: 10,
      bankAccType: "beneficiary",
      actortype: "",
      actorId: ""
    });
  }
  get loadingBeneficiary() {
    return BeneficiaryAccountController.isLoading;
  }
  get beneficiaryDetail() {
    return BeneficiaryAccountController.beneficiaryList.data.filter(
      (beneficiary: any) => {
        return beneficiary.bankAccountType === "beneficiary";
      }
    );
  }
  get beneficiaryModelValue() {
    if (this.beneficiaryDetail.length > 0) {
      return `${this.beneficiaryDetail[0]?.bankAccountName} - ${this.beneficiaryDetail[0].bankAccountNumber}`;
    }
    return "-";
  }

  get dataProfile() {
    return AccountController.accountData;
  }
  isPasswordValidate = false;
  validatePasswordAccount = debounce(async (e: any) => {
    const value = e.target.value;
    if (value.length === 0) {
      AuthController.setErrorPassword(false);
      this.isPasswordValidate = false;
      return;
    }
    this.isPasswordValidate = await AuthController._onCheckPassword({
      email: this.dataProfile.username || this.dataProfile.email,
      password: e.target.value
    });
  }, 500);
  get isWrongPassword() {
    return AuthController.isErrorWrongPassword;
  }

  FlagsOtp = FlagsOtp;
  onSubmitWithdraw() {
    if (this.isRolloutOn) {
      this.onCheckCaptchaAndValidAccount();
      return;
    }

    this.onCallWithdraw();
  }

  onUpdateOpenOtp(value: boolean) {
    this.isModalOtp = value;
  }

  onVerify(otp: string, token: string) {
    this.onCallWithdraw(otp, token);

    this.isModalOtp = false;
  }

  get actionRequestOtp() {
    return this.props.balanceType === "balance" ? "withdraw" : "withdraw_cod";
  }

  async onCheckCaptchaAndValidAccount() {
    const action =
      this.props.balanceType === "balance"
        ? "otp_enable_wd_saldo"
        : "otp_enable_wd_cod";
    try {
      const captchaToken = await recaptchaV3.executeRecaptcha(action);
      MainAppController.showLoading();
      const res = await AuthController.requestOtp(
        new OtpRequest({
          password: this.password,
          captchaToken,
          action: this.actionRequestOtp
        })
      );

      this.tokenFromOTP = res.token;
      this.emailUser = res.emailPartnerClient;
      this.phoneUser = res.phoneNumberPartnerClient;
      this.onUpdateOpenOtp(true);
      this.errorMessageOtp = "";
    } catch (error) {
      this.errorMessageOtp = (error as any)?.response?.data?.message?.id;
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onCallWithdraw(otp = "", token = "") {
    if (this.isDisabled) {
      return;
    }
    const response = await BalanceController.withdrawBalance(
      new WithdrawBalanceRequest({
        amount: parseByCountry(this.amountWithdrawal, { country: this.countryCode }),
        version: AccountController.accountData.isPosAccount
          ? FlagsMedusa.config_version_endpoint_withdraw_pos.getValue()
          : "v1",
        token: token || this.tokenFromOTP,
        otp,
        password: this.password
      })
    );
    if (response) {
      this.props.onClose();
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          title: "Permintaan Berhasil !",
          message:
            "Permintaan penarikan saldo berhasil. Mohon menunggu proses pencairan dalam waktu maks. 14 hari kerja.",
          textSuccess: "OK",
          onSubmit: () => this.onSubmitSuccessModal(),
          image: "image-modal-success"
        })
      );
      await BalanceController.getBalance(true);
    }
  }

  onSubmitSuccessModal() {
    MainAppController.closeMessageModal();
    this.props.onClose();
  }

  get activeCashbackConfig() {
    return AccountController.activeCashback.data;
  }

  get isAnyCashbackConfigActive() {
    return (
      AccountController.accountData.isPosAccount &&
      this.activeCashbackConfig.ccbId &&
      this.activeCashbackConfig.ccbStatus.toLowerCase() === "active"
    );
  }

  get isShowRunningText() {
    return !!FlagsMedusa.information_running_text.getValue().replace(" | ", "");
  }

  get isRolloutOn() {
    const isBalanceWithOTP =
      FlagsOtp.otp_enable_wd_saldo.isEnabled() &&
      this.props.balanceType === "balance";
    const isCodWithOTP =
      FlagsOtp.otp_enable_wd_cod.isEnabled() &&
      this.props.balanceType === "cod";

    return isBalanceWithOTP || isCodWithOTP;
  }
}
